import { LearningProgressLearnerDetailPage } from "@/features/learning-progress/pages/LearningProgressLearnerDetail";

export default LearningProgressLearnerDetailPage;
